import React, { useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';

import { fetchConToken } from '../../../api/fetch';
import { useForm } from '../../../hooks/useForm';
import { useContextInfo } from '../../../context/ContextInfo';

const ModBono = ({ show, onClose, callBk, id }) => {
    const { setResp } = useContextInfo();
    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const [values, handleInputChange, reset] = useForm({
        id: '',
        meses: '',
        nota: '',
    });

    const funClose = () => {
        reset();
        onClose();
    };

    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(`usertools/bonus`, { ...values, id }, 'POST');
            setResp(res);
            if (res.ok) {
                callBk();
                reset();
                onClose();
            }
        }
    };
    return (
        <Modal show={show} onHide={funClose}>
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">Bonificación</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label>Meses</Form.Label>
                                            <Form.Control
                                                required
                                                type="number"
                                                value={values.meses}
                                                name="meses"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCusto">
                                            <Form.Label>Concepto</Form.Label>
                                            <Form.Control
                                                value={values.nota}
                                                name="nota"
                                                required
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModBono;
